import { useTranslation } from 'react-i18next'
import { KibButtonNew } from '@chewy/kib-controls-react'
import { KibModal } from '@chewy/kib-overlays-react'

import '@chewy/kib-controls-styles/dist/styles/kib-button-new.css'
import '@chewy/kib-overlays-styles/dist/styles/kib-modal.css'
import styles from './ModalControls.module.scss'

export interface SummarizeNavigationModalProps {
  onCancel: () => void
  onConfirm: () => void
  open: boolean
  patientName: string
}

const SummarizeNavigationModal = ({
  open,
  onCancel,
  onConfirm,
  patientName,
}: SummarizeNavigationModalProps) => {
  const { t } = useTranslation(['Dialogs'])

  const controls = () => (
    <div className={styles.controls}>
      <KibButtonNew emphasis="tertiary" theme="action" onClick={onCancel}>
        {t('AUDIO_RECORDER.SUMMARIZE_NAVIGATION_MODAL.CANCEL_BUTTON')}
      </KibButtonNew>
      <KibButtonNew theme="action" onClick={onConfirm}>
        {t('AUDIO_RECORDER.SUMMARIZE_NAVIGATION_MODAL.CONFIRM_BUTTON')}
      </KibButtonNew>
    </div>
  )

  return (
    <KibModal
      controls={controls}
      open={open}
      title={t('AUDIO_RECORDER.SUMMARIZE_NAVIGATION_MODAL.TITLE')}
      onClose={onCancel}
    >
      <p>
        {t('AUDIO_RECORDER.SUMMARIZE_NAVIGATION_MODAL.MESSAGE', {
          patientName,
        })}
      </p>
    </KibModal>
  )
}

export default SummarizeNavigationModal
